import { styled } from '@mui/material'
import TableCellBase, { tableCellClasses } from '@mui/material/TableCell'
import TableContainerBase from '@mui/material/TableContainer'
import TableRowBase from '@mui/material/TableRow'
import TableSortLabelBase from '@mui/material/TableSortLabel'

export const TableContainer = styled(TableContainerBase)(({ theme }) => ({
  '& .MuiTable-root': {
    borderCollapse: 'separate',
    borderSpacing: `0 ${theme.spacing.S}`,
  },

  '& .MuiTable-root th, .MuiTable-root td': {
    border: 0,
  },

  '& .MuiTable-root .MuiTableBody-root': {
    cursor: 'pointer',
    '.MuiTableRow-root:hover': {
      backgroundColor: theme.palette.primary.disabled,
    },
  },
})) as typeof TableContainerBase

export const TableRow = styled(TableRowBase)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  '&.MuiTableRow-root td:first-child': {
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
  },

  '&.MuiTableRow-root td:last-child': {
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
  },
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.primary.lightest,
  },
})) as typeof TableRowBase

export const TableCell = styled(TableCellBase)(({ theme }) => ({
  height: theme.size[16],
  padding: `0 ${theme.spacing.L}`,
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.text.placeholder,
    padding: 0,
  },
})) as typeof TableCellBase

export const TableSortLabel = styled(TableSortLabelBase)(({ theme }) => ({
  '& .MuiTypography-root': { color: theme.palette.text.placeholder },
  '&:hover .MuiTableSortLabel-icon': {
    opacity: 1,
  },
  '& .MuiTableSortLabel-icon': {
    fill: theme.palette.text.placeholder,
    opacity: 1,
    '&:hover': {
      opacity: 1,
    },
  },
  '&.Mui-active .MuiTypography-root': {
    color: theme.palette.primary.main,
  },
  '&.Mui-active .MuiTableSortLabel-icon': {
    fill: theme.palette.primary.main,
  },
})) as typeof TableSortLabelBase
